import React from 'react'
import styles from './styles.css'

export default function SmallSelect({value, onChange, options = [], noValueLabel}) {
  return (
    <div className={styles.container}>
      <select
        className={value ? styles.select : styles.noValue}
        value={value || ''}
        onChange={event => onChange(event.target.value)}>
        {noValueLabel ? <option value="">{noValueLabel}</option> : null}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
